<template>
  <div class="light:bg-gray-50 dark:bg-gray-800 h-full">
    <!-- <h1 class="text-2xl text-center text-gray-800 m-10">Settler Exchange II</h1> -->
    <div class="logo-section text-center p-10">
      <!-- <img
        src="/img/settler-exchange-logo A light bg stacked.png"
        class="w-[80%] max-w-[250px] m-auto"
      > -->
      <img
        v-show="colorMode.value == 'light'"
        src="/img/settler-exchange-logo B light bg stacked.png"
        class="w-[80%] max-w-[250px] m-auto"
      >
      <img
        v-show="colorMode.value == 'dark'"
        src="/img/settler-exchange-logo B dark bg stacked.png"
        class="w-[80%] max-w-[250px] m-auto"
      >
    </div>

    <div v-if="user" class="text-center p-10">
      Welcome back, {{ user.user_metadata.name }}!
      <UButton variant="link" @click="signOut">Log out</UButton>
    </div>

    <UAlert
      v-show="!user"
      title="Well this is pretty nifty"
      variant="subtle"
      color="neutral"
      class="m-auto max-w-lg mb-10"
      icon="i-lucide-shield-user"
    >
      <template #description>
        <div>
          <UButton to="/register" variant="link" class="px-0"
            >Create an account</UButton
          >
          and log in to store and access your game history!
        </div>
      </template>
    </UAlert>

    <div class="text-center">
      <UButton to="/game/setup" size="xl">Start a new game</UButton>

      <UButton
        v-show="!user"
        class="ml-2"
        to="/login"
        size="xl"
        color="neutral"
        variant="outline"
        >Log in</UButton
      >

      <div>
        <UButton
          class="mt-15"
          variant="subtle"
          icon="i-lucide-coffee"
          to="https://buymeacoffee.com/settlerexchange"
          target="_blank"
          label="Buy me a coffee"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const user = useSupabaseUser();
const colorMode = useColorMode();

async function signOut() {
  const supabase = useSupabaseClient();
  const toast = useToast();

  const { error } = await supabase.auth.signOut();
  if (error) {
    toast.add({
      color: "error",
      title: "Unable to sign out",
      description: error.message,
    });
  } else {
    navigateTo("/login");
  }
}
</script>

<style></style>
